import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'countdown-timer',
  template: ``,
  standalone: true,
})
export class CountDownTimerAppComponent implements OnInit, OnDestroy {
  @Input() seconds: number;
  @Output() formattedTime = new EventEmitter<string>();
  @Output() countdownFinished = new EventEmitter<void>();

  private intervalId: ReturnType<typeof setInterval>;
  private remaining: number;

  ngOnInit(): void {
    this.remaining = this.seconds;
    this.emitTime();

    this.intervalId = setInterval(() => {
      this.remaining--;
      if (this.remaining >= 0) {
        this.emitTime();
      } else {
        clearInterval(this.intervalId);
        this.countdownFinished.emit();
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private emitTime(): void {
    const min = Math.floor(this.remaining / 60);
    const sec = this.remaining % 60;
    this.formattedTime.emit(`${min}:${sec.toString().padStart(2, '0')}`);
  }
}
